import { Transform } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';

export class PathfinderOutboundRequestModel {
	success: boolean;
	request_id: number;
}

export interface PathfinderOutboundRequestArgument {
	request_type: 'LearningPlanScheduling' | 'LearningPlanHydration';
	user_id: number;
}

export class PathfinderViewRequestModel {
	id: number;
	learning_plan_id: number;
	type: 'hydration' | 'scheduling';
	status: number;
	@Transform(dateTransformer)
	created_timestamp: Date;
	@Transform(dateTransformer)
	requested_timestamp: Date | null;
	@Transform(dateTransformer)
	completed_timestamp: Date | null;
	processing_time: number | null;
	response: {
		user_id: number;
		request_id: number;
		processing_time: number;
		// USED FOR hydration type
		recommended_sections?: {
			section_id: number;
			success_probability: number;
		}[];
		// USED FOR scheduling type

		sections?: {
			section_id: number;
			rank_ordering: number;
			success_probability: number;
		}[];
		errors?: string[]; // USED FOR scheduling type only I think
	};
}
